import { useState, useEffect } from 'react'
import { Header } from './Header'
import { HeroSection } from './HeroSection'
import { TemplatesMarquee } from './TemplatesMarquee'
import { BrandSection } from './BrandSection'
import { CTAsection } from './CTAsection'
import { Footer } from './Footer'
import Filler1 from './About'
import CommunitySection from './Community'



export default function LandingPage() {

    const [scrollY, setScrollY] = useState(0)

    useEffect(() => {
        const handleScroll = () => setScrollY(window.scrollY)
        window.addEventListener('scroll', handleScroll)
        return () => window.removeEventListener('scroll', handleScroll)
    }, [])

    const templates = [
        {
            name: 'Creator',
            gradient: 'from-purple-500 to-pink-500',
            links: ['Latest Video', 'Join Members', 'Shop Merch']
        },
        {
            name: 'Artist',
            gradient: 'from-blue-500 to-purple-500',
            links: ['New Album', 'Tour Dates', 'Music Videos']
        },
        {
            name: 'Business',
            gradient: 'from-green-500 to-blue-500',
            links: ['Our Services', 'Book a Call', 'About Us']
        },
        {
            name: 'Personal',
            gradient: 'from-orange-500 to-red-500',
            links: ['Portfolio', 'Resume', 'Contact']
        }
    ]

    return (
        <div className="min-h-screen bg-white">
            <Header />
            <HeroSection />
            <Filler1 />
            <TemplatesMarquee templates={templates} />
            <BrandSection />
            <CommunitySection />
            <CTAsection />
            <Footer />

            <style jsx>{`
                @keyframes marquee {
                    0% {
                        transform: translateX(0);
                    }
                    100% {
                        transform: translateX(-50%);
                    }
                }
                .animate-marquee {
                    animation: marquee 30s linear infinite;
                }
            `}</style>
        </div>
    )
}